import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { ScheduleService } from '../../_services/schedule.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-store-opening-times',
    templateUrl: './store-opening-times.component.html',
    styleUrls: ['./store-opening-times.component.css'],
})
export class StoreOpeningTimesComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    cookieStore: any;

    selectedTime: any;

    role: any;
    routeRole: any;

    existingOpeningHours: any[] = [];

    daysOfWeek: DayOfWeek[] = [];
    dayHours: DayHours[] = this.globals.dayHours;
    hourMins: HourMins[] = this.globals.hourMins;

    selectedWeekDays: DayOfWeek[];
    openingHoursModal = false;
    openingHoursForm: FormGroup;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService,
        public _scheduleService: ScheduleService,
        public confirmationService: ConfirmationService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];

        this.daysOfWeek = this.globals.daysOfWeek;

        this.openingHoursForm = fb.group({
            days: [],
            startTimeHour: 0,
            startTimeMinute: 0,
            endTimeHour: 0,
            endTimeMinute: 0,
        });
    }

    ngOnInit() {
        this.getStore(this.storeId);
        this.getCurrentOpeningHours(this.storeId);
    }

    public toggleOpeningHoursModal() {
        this.openingHoursModal = !this.openingHoursModal;
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                // console.log('Selected Store -> ', data);
                this.selectedStore = data;
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    // Get Existing Store Schedules
    public getCurrentOpeningHours(storeid) {
        this._scheduleService.getStoreSchedules(storeid).subscribe((data: any) => {
            // console.log('Existing Schedules -> ', data);
            this.existingOpeningHours = data;
        });
    }

    public onOpeningHoursFormSubmit() {
        const values = this.openingHoursForm.value;
        // console.log('Form Values - ', values);

        if (
            !values.days ||
            !values.days.length ||
            !values.startTimeHour.value ||
            !values.startTimeMinute.value ||
            !values.endTimeHour.value ||
            !values.endTimeMinute.value
        ) {
            this.notificationService.notify(
                'danger',
                'Error',
                'Please complete all fields',
                'top',
                'right'
            );
        } else {
            this.toggleOpeningHoursModal();
            values.days.forEach((element) => {
                const obj = {
                    dayOfWeek: element.value,
                    startTimeHour: values.startTimeHour.value,
                    startTimeMinute: values.startTimeMinute.value,
                    endTimeHour: values.endTimeHour.value,
                    endTimeMinute: values.endTimeMinute.value,
                };
                this._scheduleService.createStoreSchedule(this.storeId, obj).subscribe((data: any) => {
                    this.openingHoursForm.reset();
                    this.getCurrentOpeningHours(this.storeId);
                    this.notificationService.notify(
                        'success',
                        'Opening Hours Added',
                        'New Opening Hours successfully added',
                        'top',
                        'right'
                    );
                });
            });
        }
    }

    public deleteTimeslot(timeslot) {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to delete this timeslot?',
            accept: () => {
                this.performDeleteSlot(timeslot);
            },
        });
    }

    performDeleteSlot(timeslot) {
        // Actual logic to perform a confirmation
        this._scheduleService.deleteSchedule(timeslot.id).subscribe((data: any) => {
            console.log(data);
            this.notificationService.notify(
                'success',
                'Timeslot Deleted',
                'Timeslot has successfully been deleted',
                'top',
                'right'
            );
            this.getCurrentOpeningHours(this.storeId);
        });
    }

    public deleteAllTimeslot() {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to delete all timeslots?',
            accept: () => {
                this.existingOpeningHours.forEach((timeslot) => {
                    this.performDeleteSlot(timeslot);
                });
            },
        });
    }
}

interface DayOfWeek {
    name: String;
    value: Number;
}

interface DayHours {
    name: String;
    value: String;
}

interface HourMins {
    value: String;
}



// WEBPACK FOOTER //
// ./src/app/indi-store/opening-times/store-opening-times.component.ts